import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[slug]/funnel/components/PropertyFunnel.jsx");
